// QuickBooks Online integration types. Mirror the Go DTOs in
// internal/modules/quickbooks/application/dto.go and the Postgres enums in
// migration 000033_create_quickbooks_tables.up.sql.

export type QboConnectionStatus = 'connected' | 'expired' | 'disconnected'

export interface QboStatus {
  connected: boolean
  simulation: boolean
  company_name: string
  realm_id: string
  status: string
  default_income_account_name: string
  last_sync_at: string | null
  needs_setup: boolean
  pending_sync_count: number
}

export interface QboConnectStart {
  url?: string
  state: string
  simulation: boolean
}

export type QboSyncStatus = 'pending' | 'synced' | 'failed' | 'skipped'
export type QboSyncEntityType = 'customer' | 'invoice' | 'payment'

export interface QboSyncLogEntry {
  id: string
  entity_type: QboSyncEntityType
  local_id: string
  operation: 'create' | 'update' | 'void'
  status: QboSyncStatus
  qbo_id?: string
  error?: string
  attempts: number
  next_retry_at?: string | null
  updated_at: string
}

export const QBO_SYNC_STATUS_LABELS: Record<QboSyncStatus, string> = {
  pending: 'Pending',
  synced: 'Synced',
  failed: 'Failed',
  skipped: 'Skipped',
}

export const QBO_SYNC_STATUS_VARIANT: Record<QboSyncStatus, 'default' | 'secondary' | 'destructive' | 'outline'> = {
  synced: 'default',
  pending: 'secondary',
  skipped: 'outline',
  failed: 'destructive',
}

export const QBO_ENTITY_LABELS: Record<QboSyncEntityType, string> = {
  customer: 'Customer',
  invoice: 'Invoice',
  payment: 'Payment',
}
